'use client';

import classNames from 'classnames';
import { HeadingTag, TitleDescription } from '@sapientpro/sapientpro-data-models';
import styles from './CaseRevealingPoints.module.scss';
import DynamicHeading from '../../../../components/DynamicHeading';

interface ICaseRevealingPointsItemProps {
  data: TitleDescription;
  headingTag: HeadingTag;
  onStateChange: () => void;
  isActive: boolean;
}

const CaseRevealingPointItem = ({
  data, headingTag, onStateChange, isActive,
}: ICaseRevealingPointsItemProps) => (
  <button
    type='button'
    onClick={onStateChange}
    className={classNames(styles.revealingPoint, {
      [styles.active]: isActive,
    })}
  >
    <div className={styles.pointContent}>
      <DynamicHeading
        headingTag={headingTag}
        className={styles.pointTitle}
        nestingLevel={1}
      >
        {data.title}
      </DynamicHeading>
      <p className={styles.pointText}>{data.description}</p>
    </div>
    <svg className={styles.pointIcon}>
      <use
        xlinkHref='/media/arrow-right-bold.svg#arrowRight'
        href='/media/arrow-right-bold.svg#arrowRight'
      />
    </svg>
  </button>
);

export default CaseRevealingPointItem;
